export const emailRegexp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/gm;

// utils/regexp.js
export const emailUserRegexp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/im;
export const passwordRegexp = /^[A-Za-zА-Яа-я0-9 _@+\-:.]+$/im;
export const upperCaseRegexp = /[A-ZА-Я]/;
export const lowerCaseRegexp = /[a-zа-я]/;
export const numberRegexp = /\d/;
